import React from 'react';
import categoryModel from './model/categoryModel';
import { SelectBasePrototype, Select } from 'clad';

const { Option } = Select;

export const SelectCategory = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder, labelInValue } = props;

    const handleFetch = ({ query, id, pagination }) => {
        return categoryModel.list({ query, id });
    };

    const renderOptions = data => {
        return data.map(row => {
            return (
                <Option key={row.id} value={row.id}>
                    <div
                        id="boot"
                        style={{
                            background: 'transparent',
                            margin: 6,
                            cursor: 'initial !important'
                        }}
                    >
                        <span
                            className={
                                'label category-label category-' + row.id
                            }
                            style={{
                                float: 'left',
                                padding: '2px 8px 2px 8px',
                                top: '-4px',
                                position: 'relative'
                            }}
                        >
                            {row.name}
                        </span>
                    </div>
                </Option>
            );
        });
    };

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a category')}
            schema={{ idOption: 'id', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
            labelInValue={labelInValue || false}
            renderOptions={data => renderOptions(data)}
            pageSize={1}
        />
    );
});
